import styled from 'styled-components'

export const StudentGradeBreakdownContainer = styled.div`
  display: grid;
  grid-auto-rows: 1fr;
  height: 95vh;
`

export const StudentGradeBreakdownContainerTitle = styled.div`
  justify-self: center;
  align-self: center;
  font-size: 4vh;
`
export const GradeSectionContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
`
export const SectionContainer = styled.div`
  display: grid;
  grid-template-rows: 1fr 5fr;
  font-size: 3vh;
  justify-items: center;
`
export const DisclaimerContainer = styled.div`
  text-align: center;
  font-size: 2vh;
`
